import { ThemeConfig } from 'src/app/@data-services/event-config/event-theme-config.data-model';

export const applyTheme = (config?: ThemeConfig): void => {
  const root = document.querySelector(':root') as HTMLElement;

  if (root) {
    const setProperty = (
      property: string,
      defaultValue: string,
      value?: string | undefined
    ): void => {
      root.style.setProperty(property, value || defaultValue);
    };

    const properties = [
      {
        property: '--theme-background-image',
        defaultValue: `url('./../../assets/background_default.svg')`,
        value: `url('${config?.Light?.BackgroundImage.trim()}')`,
      },
      {
        property: '--primary-gradient-start',
        defaultValue: '#2c22c0',
        value: config?.Light?.Colors?.PrimaryGradientStart,
      },
      {
        property: '--primary-gradient-end',
        defaultValue: '#8f30bc',
        value: config?.Light?.Colors?.PrimaryGradientEnd,
      },
      {
        property: '--primary-color-variant-2',
        defaultValue: '#534ad8',
        value: config?.Light?.Colors?.PrimaryColorVariant2,
      },
      {
        property: '--card-gradient-hover-start',
        defaultValue: '#2c22c014',
        value: config?.Light?.Colors?.CardGradientHoverStart,
      },
      {
        property: '--card-gradient-hover-end',
        defaultValue: '#8f30bc14',
        value: config?.Light?.Colors?.CardGradientHoverEnd,
      },
      {
        property: '--primary-background-patch-left-top',
        defaultValue: '#9155F2',
        value: config?.Light?.Colors?.BackgroundPatchLeftTop,
      },
      {
        property: '--primary-background-patch-left-middle',
        defaultValue: '#9155F2',
        value: config?.Light?.Colors?.BackgroundPatchLeftMiddle,
      },
      {
        property: '--primary-background-patch-right-middle',
        defaultValue: '#54ECD0',
        value: config?.Light?.Colors?.BackgroundPatchRightMiddle,
      },
      {
        property: '--primary-background-patch-gradient-bottom-start',
        defaultValue: '#534AD8',
        value: config?.Light?.Colors?.BackgroundPatchGradientBottomStart,
      },
      {
        property: '--primary-background-patch-gradient-bottom-end',
        defaultValue: '#834C9D',
        value: config?.Light?.Colors?.BackgroundPatchGradientBottomEnd,
      },
    ];

    properties.forEach(({ property, defaultValue, value }) => {
      setProperty(property, defaultValue, value);
    });
  }
};
